import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacbookAir: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMacbookAir"><Path d="M1 17V18.25C1 19.2165 1.7835 20 2.75 20H21.25C22.2165 20 23 19.2165 23 18.25V17H14.8939L13.9189 17.5H10.1659L9.09089 17H1Z" fill="currentColor"/><Path d="M2 4V16H22V4H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMacbookAir;
